// UTM helper for the Dexcom landing page.
const UTM_PARAMS: Record<string, string> = {
  utm_source: "siemens-wl",
  utm_medium: "siemens-wl",
  utm_campaign: "siemens-wl",
};

// Map page lang -> naboo.app locale prefix. FR has no prefix (root).
const NABOO_LOCALE: Record<string, string> = {
  fr: "",
  en: "/en-us",
  es: "/es-es",
  nl: "/nl-nl",
  de: "/de-de",
  it: "/it-it",
  pt: "/pt-pt",
};

const KNOWN_PREFIXES = ["/fr-fr", "/en-us", "/es-es", "/nl-nl", "/de-de", "/it-it", "/pt-pt"];

const detectPageLang = (): string | null => {
  if (typeof window === "undefined") return null;
  const p = window.location.pathname;
  if (p.startsWith("/en")) return "en";
  if (p.startsWith("/fr")) return "fr";
  if (p.startsWith("/es")) return "es";
  if (p.startsWith("/nl")) return "nl";
  if (p.startsWith("/de")) return "de";
  if (p.startsWith("/it")) return "it";
  if (p.startsWith("/pt")) return "pt";
  return null;
};

export const withUtm = (href: string, lang?: string): string => {
  if (!href) return href;
  if (!/^https?:\/\//i.test(href)) return href;
  try {
    const url = new URL(href);
    Object.entries(UTM_PARAMS).forEach(([k, v]) => {
      if (!url.searchParams.has(k)) {
        url.searchParams.set(k, v);
      }
    });

    // Localize www.naboo.app links to match the current Dexcom landing page lang.
    if (url.hostname === "www.naboo.app") {
      const pageLang = lang ?? detectPageLang();
      const hasLocalePrefix = KNOWN_PREFIXES.some(
        (pre) => url.pathname === pre || url.pathname.startsWith(pre + "/")
      );
      if (!hasLocalePrefix && pageLang && NABOO_LOCALE[pageLang]) {
        const prefix = NABOO_LOCALE[pageLang];
        url.pathname = prefix + (url.pathname === "/" ? "" : url.pathname);
      }
    }

    return url.toString();
  } catch {
    return href;
  }
};
